import script from "./liveVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./liveVideo.vue?vue&type=script&setup=true&lang=js"

import "./liveVideo.vue?vue&type=style&index=0&id=1be308d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be308d9"]])

export default __exports__